// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Divider_wrapper__1m17L","divider":"Divider_divider__mqySs","divt":"Divider_divt__NcCgl","divdot":"Divider_divdot__1O5f2"};